import React, { Component } from "react";
import _ from 'i18n';


export default class EventProgressBar extends Component {


  render() {
    const { progress, number, cycleRegistrant } = this.props;
    const _progress = progress < 0 || progress > 100 ? 0 : progress;
    return (
        <div
          className='event-stats-progress-wrapper'
        >
          <div
            className='event-stats-progress-bar'
            style={{ width: `${_progress}%`}}
          />
          <div className='event-stats-progress-label'>
            {cycleRegistrant === null ? `${number}` : `${number + cycleRegistrant} (${cycleRegistrant} ${cycleRegistrant > 1 ? _("SUBSCRIBERS") : _("SUBSCRIBER")})`}
          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventProgressBar.js